"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserActivity = void 0;
var UserActivity;
(function (UserActivity) {
    UserActivity[UserActivity["WorkoutComplete"] = 1] = "WorkoutComplete";
    UserActivity[UserActivity["WorkoutRate"] = 2] = "WorkoutRate";
    UserActivity[UserActivity["WorkoutView"] = 3] = "WorkoutView";
    UserActivity[UserActivity["WorkoutBegin"] = 4] = "WorkoutBegin";
    UserActivity[UserActivity["ConsumerOpen"] = 5] = "ConsumerOpen";
    UserActivity[UserActivity["ConsumerClose"] = 6] = "ConsumerClose";
    UserActivity[UserActivity["ExerciseView"] = 7] = "ExerciseView";
    UserActivity[UserActivity["MediaView"] = 8] = "MediaView";
    UserActivity[UserActivity["StoryView"] = 9] = "StoryView";
    UserActivity[UserActivity["CancelSubscription"] = 10] = "CancelSubscription";
    UserActivity[UserActivity["InfluencerFollow"] = 11] = "InfluencerFollow";
    UserActivity[UserActivity["InfluencerUnfollow"] = 12] = "InfluencerUnfollow";
    UserActivity[UserActivity["WorkoutMark"] = 13] = "WorkoutMark";
    UserActivity[UserActivity["WorkoutUnmark"] = 14] = "WorkoutUnmark";
    UserActivity[UserActivity["WorkoutSetReminder"] = 15] = "WorkoutSetReminder";
    UserActivity[UserActivity["WorkoutDeleteReminder"] = 16] = "WorkoutDeleteReminder";
    UserActivity[UserActivity["WorkoutAddToFavourites"] = 17] = "WorkoutAddToFavourites";
    UserActivity[UserActivity["WorkoutRemoveFromFavourites"] = 18] = "WorkoutRemoveFromFavourites";
})(UserActivity || (exports.UserActivity = UserActivity = {}));
